
/**
 * Centralized base path configuration for subpath-aware deployment
 * Used for router basename and asset path construction
 * 
 * For local development testing at root slash:
 * Change to: const BASE_PATH = '/';
 * For subpath deployment (UAT/Prod):
 * Use: const BASE_PATH = '/tools/office-space-calculator';
 */
const BASE_PATH = '/tools/office-space-calculator';

module.exports = {
  BASE_PATH,
};
